import { render, staticRenderFns } from "./StudentCounselorChat.vue?vue&type=template&id=f0896cca&"
import script from "./StudentCounselorChat.vue?vue&type=script&lang=js&"
export * from "./StudentCounselorChat.vue?vue&type=script&lang=js&"
import style0 from "./StudentCounselorChat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports